import laravelAxiosClient from "../laravelAxiosClient";
import {
  AbonnementDataResult,
  CreateAbonnementDirectPayload,
  CreateAbonnementDirectResult,
  DernierAbonnementResult,
  HistoriqueAbonnementsResult,
  ReabonnementDisponibleResult,
} from "../interfaces/abonnements.interface";

export const findDernierAbonnement = async () => {
  const { data } = await laravelAxiosClient.get<DernierAbonnementResult>(
    `/abonnements/dernier-abonnement`
  );
  return data;
};

export const allowReabonnement = async () => {
  const { data } = await laravelAxiosClient.get<ReabonnementDisponibleResult>(
    `/abonnements/reabonnement-disponible`
  );
  return data;
};

export const findAllAbonnements = async () => {
  const { data } = await laravelAxiosClient.get<HistoriqueAbonnementsResult>(
    "/abonnements/historique"
  );
  return data;
};

export const findAbonnementData = async () => {
  const { data } = await laravelAxiosClient.get<AbonnementDataResult>(
    "/abonnements/abonnement-data"
  );
  return data;
};

export const createAbonnementDirect = async (payload: CreateAbonnementDirectPayload) => {
  const { data } = await laravelAxiosClient.post<CreateAbonnementDirectResult>(
    "/abonnements/direct",
    payload
  );
  return data;
};

export const getAttestationSnaFile = async (abonnementId: string) => {
  const { data } = await laravelAxiosClient.get<ArrayBuffer>(
    `/abonnements/${abonnementId}/attestation-sna-file`,
    { responseType: "arraybuffer" }
  );
  return data;
};

export const getAttestationCiteoFile = async (abonnementId: string) => {
  const { data } = await laravelAxiosClient.get<ArrayBuffer>(
    `/abonnements/${abonnementId}/attestation-citeo-file`,
    { responseType: "arraybuffer" }
  );
  return data;
};

export const getAttestationLekoFile = async (abonnementId: string) => {
  const { data } = await laravelAxiosClient.get<ArrayBuffer>(
    `/abonnements/${abonnementId}/attestation-leko-file`,
    { responseType: "arraybuffer" }
  );
  return data;
};
